import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['list', 'template', 'empty', 'row', 'destroy', 'warning', 'checkbox']

  connect() {
    this.refreshEmptyState()
  }

  add(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget || !this.hasListTarget) return
    const index = Date.now()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, index)
    this.listTarget.insertAdjacentHTML('beforeend', html)
    this.refreshEmptyState()
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest('[data-unavailability-windows-target="row"]')
    if (!row) return

    const idField = row.querySelector('input[name*="[id]"]')
    if (idField && idField.value) {
      const destroyField = row.querySelector('input[name*="[_destroy]"]')
      if (destroyField) destroyField.value = '1'
      row.classList.add('hidden')
    } else {
      row.remove()
    }

    this.refreshEmptyState()
  }

  refreshEmptyState() {
    if (!this.hasEmptyTarget || !this.hasListTarget) return
    const visibleRows = this.listTarget.querySelectorAll('[data-unavailability-windows-target="row"]:not(.hidden)')
    this.emptyTarget.classList.toggle('hidden', visibleRows.length > 0)
    this.refreshWarning()
  }

  refreshWarning() {
    if (!this.hasWarningTarget || !this.hasListTarget) return
    const visibleRows = this.listTarget.querySelectorAll('[data-unavailability-windows-target="row"]:not(.hidden)')
    const anyChecked = this.checkboxTargets.some((checkbox) => checkbox.checked)
    this.warningTarget.classList.toggle('hidden', visibleRows.length === 0 || anyChecked)
  }
}
